import { fg } from '@confluence/feature-gating';

import { getBlankPageQuickActionsExperimentEnabled } from './getBlankPageQuickActionsExperimentEnabled';

type UseShouldShowBlankPageQuickActions = {
	contentType: string;
	collabEditInitialized: boolean;
	isEditorEmpty: boolean;
	viewMode?: boolean;
};

export const useShouldShowBlankPageQuickActions = ({
	collabEditInitialized,
	contentType,
	isEditorEmpty,
	viewMode,
}: UseShouldShowBlankPageQuickActions) => {
	// skip collabEditInitialized check to render ShowBlankPageQuickActions skeleton if collabEditInitialized is false
	const collabEditInitializedCheck =
		fg('confluence_preload_blank_page_quick_actions') || collabEditInitialized;

	return (
		contentType === 'page' &&
		!viewMode &&
		collabEditInitializedCheck &&
		isEditorEmpty &&
		getBlankPageQuickActionsExperimentEnabled({
			shouldFireExperimentExposure: true,
		}).isBPQAExperimentEnabled
	);
};
